import {
  I18nFormatModule,
  LanguageDetectorAsyncModule,
  LanguageDetectorModule,
} from "i18next";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getLocales } from "expo-localization";

export const expoLanguageDetector: LanguageDetectorAsyncModule = {
  type: "languageDetector",
  async: true,
  detect: async () => {
    const lng = await AsyncStorage.getItem("lang");
    if (lng) {
      return lng;
    }

    const locales = getLocales();

    return locales[0].languageTag;
  },
  cacheUserLanguage: async function (lng) {
    return AsyncStorage.setItem("lang", lng);
  },
};
